import { core, dadata } from '@shared/modules/api';
import { localStorage } from 'src/localStorage';

export const accessToken = localStorage.get('accessToken');

core.setVariable('baseUrl', process.env.REACT_APP_API_URL);
if (accessToken) core.setVariable('accessToken', accessToken);

dadata.setVariable('apiKey', process.env.REACT_APP_DADATA_API_KEY);
